import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import { getLeaseSchemaAdditionalFields, leaseSchema } from "./lease";
import { getSubletSchemaAdditionalFields, subletSchema } from "./sublet";

export const leaseWithSubletSchema = leaseSchema.extend({
  sublets: z.array(subletSchema),
});

export type LeaseWithSublet = z.infer<typeof leaseWithSubletSchema>;

export function getLeaseWithSubletSchemaAdditionalFields(additionalFields: {
  lease: typeof additionalDataSchema;
  sublet: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
}): typeof leaseWithSubletSchema {
  return getLeaseSchemaAdditionalFields(additionalFields).extend({
    sublets: z.array(getSubletSchemaAdditionalFields(additionalFields)),
  });
}
